import React from 'react';
import { Box, Paper, Typography, List, ListItem, ListItemText, ListItemIcon, IconButton } from '@mui/material';
import { PictureAsPdf, Download } from '@mui/icons-material';

const Documents: React.FC = () => {
  const docs = [
    { id: '1', name: 'Building Rules 2026', date: '2026-01-15' },
    { id: '2', name: 'AGM Minutes March', date: '2026-03-01' },
    { id: '3', name: 'Financial Report Q1', date: '2026-03-10' }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Documents</Typography>
      <Paper>
        <List>
          {docs.map(d => (
            <ListItem key={d.id} divider secondaryAction={<IconButton><Download /></IconButton>}>
              <ListItemIcon><PictureAsPdf color="error" /></ListItemIcon>
              <ListItemText primary={d.name} secondary={d.date} />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
};
export default Documents;
